var app = angular.module("leonardo");

var TaskSnoozeDialog = function($scope, TaskService, TemplateService, $rootScope, FormErrorsService,
                                NotificationService, ngDialog, PermissionService, StatsigService, WorkOrderProviderService,
                                AuthDataService, AnalyticsService) {

  $scope.task = $scope.ngDialogData.task;
  $scope.options = TaskService.getSnoozeOptions($scope.task.recurrence_type, $scope.task.recurrence);
  $scope.dueDate = null;
  $scope.startDate = moment().format('YYYY-MM-DD');
  $scope.placeholder = moment().add(1, 'days').format('MMM D YYYY');
  $scope.manualDate = null;
  $scope.taskService = TaskService;
  $scope.permissionService = PermissionService;

  $scope.manualDateAvailable = function() {
    // Only available on Template.RECURRENCE_FIXED
    return $scope.task.recurrence_type == TemplateService.RECURRENCE_FIXED_DATE;
  };

  $scope.onOptionClicked = function(option) {
    $scope.dueDate = option.value;
    $scope.manualDate = null;
  };

  $scope.onManualDateChange = function() {
    if ($scope.manualDateAvailable()) {
      $scope.dueDate = null;
    }
  };

  $scope.getClasses = function() {
    var classes = [];
    if (!$scope.manualDateAvailable()) {
      classes.push('one-col');
    }
    if ($scope.task.recurrence_type == TemplateService.RECURRENCE_YEARLY) {
      classes.push('recurrence-yearly');
    }
    if ($scope.task.recurrence_type == TemplateService.RECURRENCE_MONTHLY) {
      classes.push('recurrence-monthly');
    }
    return classes;
  };

  $scope.showCreateWorkOrder = async function () {
    var didActivateGate = false;
    function cleanupGate() {
      if (didActivateGate) {
        StatsigService.deactivateContextualGate('work_orders_new_experience');
        didActivateGate = false;
      }
    }
    try {
      var inIframe = false;
      try {
        inIframe = window.self !== window.top;
      } catch (e) {
        inIframe = true;
      }

      const useNewExperience = inIframe ? true : await StatsigService.checkGate('work_orders_new_experience');

      if (!inIframe && useNewExperience) {
        StatsigService.activateContextualGate('work_orders_new_experience');
        didActivateGate = true;
      }
      
      WorkOrderProviderService.openWorkOrder({
        useExpoIntegration: useNewExperience,
        action: 'create',
        data: {
          task: $scope.task,
          property: $scope.task.property,
          unit: $scope.task.unit_id
        },
        closeCallback: function(result) {
          cleanupGate();
        }
      }).catch(function() {
        cleanupGate();
      });
    } catch (error) {
      console.error('[WORK_ORDER] Failed to open work order:', error);
      cleanupGate();
    }
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var date = $scope.manualDate ? $scope.manualDate : $scope.dueDate;
    if (!date) {
      return;
    }
    $scope.task.snooze({ due_date: date, snoozed: true }).then(function(data){
      $rootScope.$broadcast('task-snooze-dialog:success', data);
      $scope.closeThisDialog();
      NotificationService.notify('success', 'Task snoozed to ' + date);
    });
  };
};

app.controller('TaskSnoozeDialog', ['$scope', 'TaskService', 'TemplateService', '$rootScope', 'FormErrorsService',
  'NotificationService', 'ngDialog', 'PermissionService', 'StatsigService', 'WorkOrderProviderService',
  'AuthDataService', 'AnalyticsService', TaskSnoozeDialog]);
